import { useAccessCode } from '@rhg/hooks/use-access-code';
import { usePublicBrandingPartnerConfig } from '@rhg/hooks/use-public-branding-partner-config';
import { routes } from '@rhg/utils/routes';
import { useMemo } from 'react';

export function buildPartnerActivateDeeplinkUrl(accessCode: string): string {
    return `${
        routes.external.partnerActivateDeeplink
    }?deep_link_sub1=${encodeURIComponent(accessCode)}`;
}

export function usePartnerActivateQrUrl(fallbackUrl: string): {
    url: string;
    isFetched: boolean;
} {
    const { accessCode, isAccessCodeFromQuery, hasAccessCode } =
        useAccessCode();
    const { brandingPartnerConfig, isFetched: isBrandingPartnerConfigFetched } =
        usePublicBrandingPartnerConfig(accessCode);

    const isFetched = useMemo(
        () =>
            !isAccessCodeFromQuery || !hasAccessCode
                ? true
                : isBrandingPartnerConfigFetched,
        [hasAccessCode, isAccessCodeFromQuery, isBrandingPartnerConfigFetched]
    );

    const url = useMemo(
        () =>
            brandingPartnerConfig
                ? buildPartnerActivateDeeplinkUrl(accessCode)
                : fallbackUrl,
        [accessCode, brandingPartnerConfig, fallbackUrl]
    );

    return { url, isFetched };
}
